import React, { useMemo, useState } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildVehicles } from './vehiclesModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function Vehicles({ person, showSummary = true }) {
    const model = useMemo(() => buildVehicles(person), [person])
    const [showPast, setShowPast] = useState(false)
    if (!model.hasData) return <div className={styles.calmLine}>No vehicles, boats or aircraft found.</div>
    const { summary } = model
    return (
        <div className={styles.uccList}>
            {showSummary && (
                <div className={styles.inlineBadges}>
                    <Badge tone='neutral'>{plural(summary.current, 'current vehicle')}</Badge>
                    {summary.liens > 0 && <Badge tone='watch'>{summary.liens} with a lien</Badge>}
                    {summary.past > 0 && <Badge tone='neutral'>{summary.past} past</Badge>}
                </div>
            )}
            {model.currentVehicles.length > 0 && <RecordList items={model.currentVehicles} />}
            {model.pastVehicles.length > 0 && (
                <>
                    <div className={styles.listActions}>
                        <button type='button' className={styles.textButton} onClick={() => setShowPast(v => !v)} aria-expanded={showPast}>
                            {showPast ? 'Hide past vehicles' : `Show ${plural(model.pastVehicles.length, 'past vehicle')}`}
                        </button>
                    </div>
                    {showPast && <RecordList items={model.pastVehicles} />}
                </>
            )}
            {model.boats.length > 0 && (
                <>
                    <div className={styles.uccGroupTitle}>{plural(model.boats.length, 'boat')}</div>
                    <RecordList items={model.boats} />
                </>
            )}
            {model.aircraft.length > 0 && (
                <>
                    <div className={styles.uccGroupTitle}>Aircraft</div>
                    <RecordList items={model.aircraft} />
                </>
            )}
            {model.pilots.length > 0 && (
                <>
                    <div className={styles.uccGroupTitle}>{plural(model.pilots.length, 'pilot certificate')}</div>
                    <RecordList items={model.pilots} />
                </>
            )}
        </div>
    )
}
